import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Coinflip } from '../interfaces/coinflip.interface';
import { CoinflipCoinComponent } from '../../../features/coinflip/coinflip-coin/coinflip-coin.component';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-coinflip-stats-list',
  templateUrl: './coinflip-stats-list.component.html',
  styleUrl: './coinflip-stats-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CoinflipCoinComponent],
})
export class CoinflipStatsListComponent {
  readonly history = input<Coinflip[]>([]);

  constructor(private modalService: ModalService) {}

  viewGame(game: Coinflip) {
    this.modalService.openModal('CoinflipModal', {
      coinflip: game,
    });
  }
}
